module.exports = __webpack_public_path__ + "img/copie.d6d8101e.png";